import type { Segment, SegmentAnalysisRole } from "../types"

import { isSegmentOwner } from "./segment-analysis-utils"

/**
 * Edit/run/decide permission for ONE specific segment, mirroring the backend's
 * ``can_edit_segment`` (services/segment_analysis_permissions.py):
 *
 *   admin  → any segment
 *   viewer → never
 *   owner  → only segments they own (``ownerOid`` match, else the legacy
 *            display-name match — same as ``is_owner_of``)
 *
 * Drill-ins (company dossier, CCP, Competitor Plan) are opened for a concrete
 * segment that is not necessarily the one selected in the portfolio grid, so
 * they must resolve permission from THEIR segment, never from the selection.
 * An unknown segment id is never editable for a non-admin. The backend stays
 * the authority; this only decides which controls to show.
 */
export function canEditSegmentById({
  segmentId,
  segments,
  role,
  currentUserOid,
  currentUserName,
}: {
  segmentId: string | null | undefined
  segments: Segment[]
  role: SegmentAnalysisRole
  currentUserOid?: string | null
  currentUserName?: string | null
}): boolean {
  if (role === "admin") return true
  if (role !== "owner" || !segmentId) return false
  const segment = segments.find((candidate) => candidate.id === segmentId)
  if (!segment) return false
  return isSegmentOwner(segment, currentUserOid, currentUserName)
}
